// The browser's language, sent to Plausible with every event as browser_lang
// ("es") and browser_lang_full ("es-US"), the same properties evt.live sends
// (eventlive-domain utils/acceptLanguage.mjs reads them from the
// Accept-Language header) and www.eventlive.pro sends
// (lib/browser-language.ts). This reads navigator.languages, the order that
// header is built from.

export const UNKNOWN_LANGUAGE = "unknown";

// Withdrawn ISO 639 codes that old Android and Java clients still send.
const LEGACY_LANGUAGES = { in: "id", iw: "he", ji: "yi" };

// A lowercased language tag: a 2–3 letter language, then optional script,
// region, variant or extension subtags.
const TAG = /^[a-z]{2,3}(?:-[a-z0-9]{1,8})*$/;

// RFC 5646 §2.1.1 casing: scripts "Hant", regions "TW", the rest lowercase,
// and everything after a singleton (-u-, -x-) lowercase.
const caseSubtags = (subtags) => {
  let afterSingleton = false;
  return subtags.map((subtag) => {
    if (subtag.length === 1) afterSingleton = true;
    if (afterSingleton) return subtag;
    if (subtag.length === 2) return subtag.toUpperCase();
    if (/^[a-z]{4}$/.test(subtag))
      return subtag[0].toUpperCase() + subtag.slice(1);
    return subtag;
  });
};

/** { lang: "zh", full: "zh-Hant-TW" } for the first usable language, else "unknown" for both. */
export const browserLanguage = (languages) => {
  for (const raw of languages || []) {
    // Some apps send "en_US".
    const tag = String(raw).trim().replace(/_/g, "-").toLowerCase();
    if (!TAG.test(tag)) continue;
    const [language, ...subtags] = tag.split("-");
    const lang = LEGACY_LANGUAGES[language] || language;
    return { lang, full: [lang, ...caseSubtags(subtags)].join("-") };
  }
  return { lang: UNKNOWN_LANGUAGE, full: UNKNOWN_LANGUAGE };
};
